import { render, staticRenderFns } from "./EditRecordModal.vue?vue&type=template&id=65fc8270&"
import script from "./EditRecordModal.vue?vue&type=script&lang=js&"
export * from "./EditRecordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65fc8270')) {
      api.createRecord('65fc8270', component.options)
    } else {
      api.reload('65fc8270', component.options)
    }
    module.hot.accept("./EditRecordModal.vue?vue&type=template&id=65fc8270&", function () {
      api.rerender('65fc8270', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/ZoneEditor/EditRecordModal.vue"
export default component.exports